module.exports = __webpack_public_path__ + "static/media/careersPro_logo_transparent_S.abfe6ffb.svg";